import React from 'react'
import deepEqual from 'fast-deep-equal'
import { BidHistoryTooltip } from '../bid_history_tooltip'
import { axiosPatch } from '../../util/api'
import { Toasts } from '../toaster/Toast'
import TargetPerformance = Models.TargetPerformance
import { UpdateReportAdTypes } from '../../util/contstants'
import { InheritableBidField } from '../bids/InheritableBidField'
import { canClearInheritedBid } from '../bids/inheritedBidClearPolicy'

interface BidChangeProps {
    target: TargetPerformance
    extra: any
    disabled: boolean
}

export class TargetBidChange extends React.Component<BidChangeProps> {
    shouldComponentUpdate(nextProps: Readonly<BidChangeProps>): boolean {
        return (
            !deepEqual(nextProps.target, this.props.target) ||
            !deepEqual(nextProps.extra, this.props.extra)
        )
    }

    render() {
        const { target, extra, disabled } = this.props
        return (
            <BidHistoryTooltip
                id={target.target_id}
                type={UpdateReportAdTypes.Targets}
                campaign_id={target.campaign_id}
                bid={target.bid ?? undefined}
                bidLimits={(target as any).bid_limits}
                bid_strategy={target.bid_strategy}
                bid_adjustment_top_of_search={target.bid_adjustment_top_of_search}
                bid_adjustment_rest_of_search={target.bid_adjustment_rest_of_search}
                bid_adjustment_home_page={target.bid_adjustment_home_page}
                bid_adjustment_product_page={target.bid_adjustment_product_page}
                ad_group_default_bid={target.ad_group_default_bid}
            >
                <InheritableBidField
                    bid={target.bid}
                    adGroupDefaultBid={target.ad_group_default_bid}
                    disabled={disabled}
                    allowClear={canClearInheritedBid((target as any).profile_id)}
                    onSave={(cents) => updateBid(target.target_id, cents, extra)}
                />
            </BidHistoryTooltip>
        )
    }
}

const updateBid = (id: number, bid: number | null, extra: any) =>
    axiosPatch(`targets/${id}`, { bid })
        .then(() => {
            Toasts.success('Bid successfully updated.')
            extra.reload()
        })
        .catch((err) => {
            if (err.response?.status === 409) {
                const ids = Object.keys(err.response.data)

                Toasts.warning(
                    `${ids.length} items were out of sync. Please review the changes and retry.`,
                )
                extra.reload()
            }
            throw err
        })
